/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Close_LabelInputs */

const en_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ru_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const es_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const zh_cn2_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const hi_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const pt_pt2_segment_event_group_close_label = /** @type {(inputs: Segment_Event_Group_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Segment_Event_Group_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_close_label = /** @type {((inputs?: Segment_Event_Group_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_close_label(inputs)
	if (locale === "de") return de_segment_event_group_close_label(inputs)
	if (locale === "it") return it_segment_event_group_close_label(inputs)
	if (locale === "ru") return ru_segment_event_group_close_label(inputs)
	if (locale === "es") return es_segment_event_group_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_close_label(inputs)
	if (locale === "ja") return ja_segment_event_group_close_label(inputs)
	if (locale === "hi") return hi_segment_event_group_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_close_label(inputs)
	return en_segment_event_group_close_label(inputs)
});